<template>
  <v-card color="transparent" class="elevation-0 flex-grow-1">
    <v-card-title>
      ENS
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="jobs"
      :items-per-page="-1"
      class="elevation-1"
    >
      <template v-slot:item.implantations="{ item }">
        {{ item.implantation }}
      </template>

      <template v-slot:item.doublons="{ item }">
        <v-chip
          v-if="item.doublons > 1"
          label
          small
          color="error"
        >
          <span class="text-caption">x {{ item.doublons }}</span>
        </v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'EnsJobsTable',

  props: {
    jobs: Array,
  },

  data() {
    return {
      headers: [
        { text: 'NUMERO', value: 'numero' },
        { text: 'COURS', value: 'nom' },
        { text: 'FONCTION', value: 'fonction' },
        { text: 'VOLUME', value: 'volume' },
        { text: 'IMPLANTATION', value: 'implantations' },
        { text: '', value: 'doublons' },
      ],
    };
  },

  methods: {
    open(item) {
      this.$router.push(`/vacant-jobs/${item.id}`);
    },
  },
};
</script>
